import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Guía de Planificación Anual',
    desc: 'Clases de 45, 60 y 80 min listas por tomo.',
    value: 'USD 15'
  }, {
    num: '2',
    title: 'Banco de 80+ Ejercicios Anti-IA',
    desc: 'Actividades que ChatGPT no puede resolver.',
    value: 'USD 12'
  }, {
    num: '3',
    title: 'Errores Comunes y Cómo Explicarlos',
    desc: 'Analogía perfecta para cada error de código.',
    value: 'USD 10'
  }, {
    num: '4',
    title: '8 Evaluaciones con Rúbrica',
    desc: 'Evaluaciones listas con solución comentada.',
    value: 'USD 9'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-b border-white/5" data-id="element-17">
      <div className="max-w-2xl mx-auto" data-id="element-18">
        <div className="text-center mb-5" data-id="element-19">
          <div className="inline-flex items-center gap-1.5 bg-brand-accent/10 text-brand-accent border border-brand-accent/30 rounded-full px-3.5 py-1.5 mb-3" data-id="element-20">
            <Gift className="w-3.5 h-3.5" data-id="element-21" />
            <span className="font-bold text-[10px] md:text-xs uppercase tracking-wider" data-id="element-22">
              Sin costo extra
            </span>
          </div>
          <h2 className="text-xl md:text-3xl font-extrabold text-white uppercase tracking-tight" data-id="element-23">
            🎁 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="space-y-2.5 mb-5" data-id="element-24">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-4 border border-white/10 flex items-center gap-3" data-id="element-25">
              <div className="bg-brand-accent text-brand-dark font-extrabold text-lg rounded-xl w-10 h-10 flex items-center justify-center shrink-0" data-id="element-26">
                {bonus.num}
              </div>
              <div className="flex-1 min-w-0" data-id="element-27">
                <h3 className="text-sm md:text-base font-bold text-white leading-tight" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="text-[11px] md:text-xs text-gray-400 leading-relaxed mt-0.5" data-id="element-29">
                  {bonus.desc}
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-30">
                <p className="text-gray-500 line-through text-[10px] md:text-xs leading-none" data-id="element-31">
                  {bonus.value}
                </p>
                <p className="text-brand-accent font-bold text-xs md:text-sm leading-tight" data-id="element-32">
                  GRATIS
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-2xl p-4 text-center border border-brand-accent/30 max-w-sm mx-auto" data-id="element-33">
          <p className="text-xs md:text-sm font-medium text-gray-300" data-id="element-34">
            Valor total de bonos:{' '}
            <span className="line-through text-gray-500" data-id="element-35">USD 46</span>
          </p>
          <p className="text-2xl md:text-3xl font-extrabold text-brand-accent mt-1" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-[10px] md:text-xs text-gray-500 mt-1" data-id="element-37">
            Solo en este lanzamiento
          </p>
        </div>
      </div>
    </section>;
}